import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Card, Button, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {getDeepCopyOfBidimensionalArray, checkOrder} from '../utils';
import {inputFields, dropdownFields, PNC} from '../static/commonStructures';
import ExcelReader from '../../../excelReader/components/index';
import AddPartNumberCodeTable from './table';
import './addPnc.scss';

const INITIAL_STATE = {
  'tableValues': [],
  'disableSaveButton': true,
  'pncRepeatedInDatabase': new Set(),
};
const DATA_FIELDS = inputFields.concat(dropdownFields);

class AddPartNumberCode extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.readExcelFile = this.readExcelFile.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleTableValuesState = this.handleTableValuesState.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.pncRecord !== this.props.pncRecord) {
      const {pncRecord} = this.props;
      const updatedPncRepeatedInDatabase = new Set(
        this.state.pncRepeatedInDatabase
      );
      if (!pncRecord[0]) {
        return;
      }
      updatedPncRepeatedInDatabase.add(pncRecord[0].partNumberCode);
      this.setState({'pncRepeatedInDatabase': updatedPncRepeatedInDatabase});
    }
    if (prevState.tableValues !== this.state.tableValues) {
      const {tableValues} = this.state;
      if (!tableValues.length) {
        this.setState(INITIAL_STATE);
        return;
      }
      tableValues.some((row) => {
        this.setState({'disableSaveButton': this.isRowInvalid(row)});
        return this.isRowInvalid(row);
      });
    }
  }

  checkPncDuplication(fieldValue, columnName = PNC) {
    const {tableValues} = this.state;

    if (columnName === PNC) {
      if (tableValues.length !== 0) {
        const pncList = tableValues.map((values) => {
          return values[0];
        });
        return (
          pncList.filter((pnc) => {
            return pnc === fieldValue;
          }).length > 1
        );
      }
    }
    return false;
  }

  isRowInvalid(row) {
    return (
      !row[0] ||
      !row[1] ||
      !row[4] ||
      !row[9] ||
      checkOrder(row[10]) ||
      this.checkPncDuplication(row[0])
    );
  }

  getPncRepeatedSet(fieldValue, columnName = PNC) {
    if (columnName === PNC) {
      this.props.getPncByCode(fieldValue || '__');
    }
  }

  truncateData(columnDetail, value) {
    const {maxLength} = columnDetail;
    if (!columnDetail.maxLength || !value) {
      return value;
    }
    return value.toUpperCase().substring(0, parseInt(maxLength, 10));
  }

  formatData(data) {
    return data.map((row) => {
      return DATA_FIELDS.map((columnDetail, columnIndex) => {
        return this.truncateData(columnDetail, row[columnIndex]);
      });
    });
  }

  handleTableValuesState(updatedTableValues) {
    this.setState({'tableValues': updatedTableValues});
  }

  handleCancelClick() {
    this.props.goBack();
  }

  async handleSaveClick() {
    const {tableValues} = this.state;
    await this.props.savePncInformation(tableValues);
    this.props.goBack();
  }

  readExcelFile(data) {
    const formattedData = this.formatData(data.slice(1, data.length));
    this.setState({'tableValues': [...formattedData]});
    formattedData.forEach((row) => {
      this.getPncRepeatedSet(row[0]);
    });
  }

  addItem() {
    const {tableValues} = this.state;
    const updatedTableValues = getDeepCopyOfBidimensionalArray(tableValues);
    const defaultArray = Array(DATA_FIELDS.length);
    const orderField = 10;
    defaultArray.fill('');
    defaultArray[orderField] = 'S';
    this.setState({'tableValues': [...updatedTableValues, defaultArray]});
  }

  renderAddItem() {
    return (
      <div className='addItem' onClick={() => this.addItem()}>
        <Icon name='add' />
        <strong>AGREGAR REGISTRO</strong>
      </div>
    );
  }

  renderTitleAndActions() {
    const {disableSaveButton} = this.state;
    const {loading} = this.props;
    return (
      <Card raised fluid className='title-bar'>
        <Grid>
          <Grid.Row>
            <Icon name='arrow left' className='arrow-left' onClick={this.handleCancelClick} disabled={loading}/>
            <Grid.Column width={10} textAlign='left'>
              <h2>Actualización de PNC</h2>
            </Grid.Column>
            <Grid.Column width={3} textAlign='right'>
              <ExcelReader onGetFile={this.readExcelFile} />
            </Grid.Column>
            <Grid.Column width={2} textAlign='right'>
              <Button
                primary
                onClick={this.handleSaveClick}
                disabled={disableSaveButton}
                loading={loading}
              >
                Guardar
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }

  render() {
    const {tableValues, pncRepeatedInDatabase} = this.state;
    return (
      <div className='pnc-add'>
        {this.renderTitleAndActions()}
        <Card fluid raised>
          <div className='horizontal-scroll'>
            <AddPartNumberCodeTable handleTableValuesState={this.handleTableValuesState}
              tableValues={tableValues} pncRepeatedInDatabase={pncRepeatedInDatabase}/>
          </div>
          {this.renderAddItem()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'goBack': ownProps.history.goBack,
    'pncRecord': state.partNumberCodeInstance.record,
    'loading': state.partNumberCodeInstance.loading,
  };
};

const {
  savePncInformation,
  getPncByCode,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  savePncInformation,
  getPncByCode,
})(AddPartNumberCode));
